import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HELP_CENTER_PATH, CONTACT_PATH } from '../../constants/siteNav';

const LINKS = [
  { to: HELP_CENTER_PATH, label: 'Help Center', match: (p) => p === '/help' },
  { to: `${HELP_CENTER_PATH}#getting-started`, label: 'Help', match: (p) => p === '/help' },
  { to: CONTACT_PATH, label: 'Contact Us', match: (p) => p === '/contact' }
];

const SupportSubNav = () => {
  const { pathname } = useLocation();

  return (
    <nav
      className="bg-white border-b border-gray-200"
      aria-label="Support navigation"
    >
      <div className="container mx-auto px-4">
        <ul className="flex items-center gap-0 overflow-x-auto scrollbar-none">
          {LINKS.map((link) => {
            const active = link.match(pathname);
            return (
              <li key={link.label} className="shrink-0">
                <Link
                  to={link.to}
                  className={`inline-block px-4 py-3.5 text-[13px] font-semibold border-b-[3px] transition-colors whitespace-nowrap ${
                    active
                      ? 'text-gray-900 border-gray-900'
                      : 'text-gray-500 border-transparent hover:text-gray-800 hover:border-gray-300'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default SupportSubNav;
